<template>
<w-settings-content-template>
  <el-tabs slot="content" class="content-tap" type="card" v-model="activeTab" @tab-click="onChangeMenu">
    <el-tab-pane label="수집서버 그룹 설정" name="WAgentGroup" class="h100 w100">
      <w-agent-group ref="agentGroup" :activeTab="activeTab" ></w-agent-group>
    </el-tab-pane>
    <el-tab-pane label="수집서버 부하 분산" name="WAgentManager" class="h100 w100">
      <w-agent-manager ref="agentManager" :activeTab="activeTab" ></w-agent-manager>
    </el-tab-pane>
  </el-tabs>
</w-settings-content-template>
</template>

<script>
import WSettingsContentTemplate from '@/components/template/SettingsContentTemplate';
import WAgentGroup from './AgentGroup';
import WAgentManager from './AgentManager';

export default {
  name: 'WAgentSettings',
  components: {
    WSettingsContentTemplate,
    WAgentGroup,
    WAgentManager,
  },
  data() {
    return {
      activeTab: 'WAgentGroup',
    };
  },
  mounted() {
    this.$refs.agentGroup.loadData();
  },
  methods: {
    onChangeMenu(menu) {
      // this.activeMenu = menu.name;
      if (menu.name === 'WAgentGroup') {
        this.$refs.agentGroup.loadData();
      } else {
        this.$refs.agentManager.loadData();
      }
    },
  },
};
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/views/settings/operation/CollectionSettings/AgentSettings/index.vue